import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { getScatterPlotFetchParams, hasValidRequestData, } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.selectors';
import { ScatterPlotChartType, ScatterPlotPresentationValidModes, ScatterPlotStatus, } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { SavedScatterPlotService } from 'Angular/features/components/saved-items/services/saved-scatter-plot.service';
import { ScatterPlotAppStateManager } from 'ChartApp/ts/apps/scatter-plot/services/scatter-plot-app-state-manager.service';
import { SelectedScatterPlotService } from 'ChartApp/ts/apps/scatter-plot/services/selected-scatter-plot.service';
import { ScatterPlotService } from 'ChartApp/ts/services/scatter-plot.service';
import { LegacyAssetConversionCheckerComponent } from 'ConverterApp/features/legacy-asset-conversion-checker/legacy-asset-conversion-checker.component';
import equal from 'Angular/utils/equal/deep-equal';
import * as i0 from "@angular/core";
import * as i1 from "Angular/features/components/saved-items/services/saved-scatter-plot.service";
import * as i2 from "@ngrx/store";
import * as i3 from "ChartApp/ts/apps/scatter-plot/services/scatter-plot-app-state-manager.service";
import * as i4 from "ChartApp/ts/services/scatter-plot.service";
import * as i5 from "ChartApp/ts/apps/scatter-plot/services/selected-scatter-plot.service";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../../../converter/static/converter/ts/features/legacy-asset-conversion-checker/legacy-asset-conversion-checker.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
const _c0 = ["presentationImage"];
const _c1 = () => ({ height: "100%" });
function ScatterPlotChartPresentationComponent_ycn_loading_symbol_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 12);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading ...");
} }
/**
 *
 * Scatter Plot Chart Presentation
 *
 * This displays the presentation chart image.
 *
 */
export class ScatterPlotChartPresentationComponent {
    constructor(changeDetectorRef, savedScatterPlotService, store, scatterPlotAppStateService, scatterPlotService, selectedScatterPlotService) {
        this.changeDetectorRef = changeDetectorRef;
        this.savedScatterPlotService = savedScatterPlotService;
        this.store = store;
        this.scatterPlotAppStateService = scatterPlotAppStateService;
        this.scatterPlotService = scatterPlotService;
        this.selectedScatterPlotService = selectedScatterPlotService;
        this.ScatterPlotStatus = ScatterPlotStatus;
        // Fetching Data
        this.isAlive = true;
        this.status = ScatterPlotStatus.getStarted;
        this.message = ScatterPlotChartPresentationComponent.GET_STARTED_MESSAGE;
        // Defined as an arrow function so that this refers to the component
        this.mapStateToComponent = (state) => {
            // Determine if we need to fetch a new scatter plot data based on changes
            // to the filter parameters.
            const currentDataParams = this.getDataParams;
            const newDataParams = {
                ...getScatterPlotFetchParams(state),
                mode: ScatterPlotPresentationValidModes.imageContents,
            };
            if (!equal(currentDataParams, newDataParams)) {
                // Update getDataParams to the most up-to-date new params.
                // This check is done regardless of whether the params make a valid request, so that we always notice when
                // params change to be able to make a valid request.
                this.getDataParams = newDataParams;
                if (hasValidRequestData(state) && state.scatterPlot.chartType === ScatterPlotChartType.presentation) {
                    // Make a request to load the scatter plot chart image
                    const img = this.presentationImage.nativeElement;
                    this.status = ScatterPlotStatus.loading;
                    // Manually set the src attribute (instead of using Angular [src] binding in the template)
                    // to always trigger the image's onload event, even if the browser cached the image.
                    // We do this so the loading symbol is removed when an image is loaded from the browser cache.
                    this.imageSource = this.scatterPlotService.getChartEmbedUrl(this.getDataParams);
                    img.src = this.imageSource;
                    // Check if the chart needs to be converted
                    const chartId = this.getDataParams.chartId;
                    if (this.legacyConverter) {
                        this.legacyConverter.reloadDiffAndCheck(chartId);
                    }
                }
            }
            if (!hasValidRequestData(state)) {
                this.status = ScatterPlotStatus.getStarted;
                this.message = ScatterPlotChartPresentationComponent.GET_STARTED_MESSAGE;
            }
            // Re-render the component with the new image
            this.changeDetectorRef.markForCheck();
            this.changeDetectorRef.detectChanges();
        };
    }
    ngAfterViewInit() {
        this.store
            .select('reducers')
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    errorHandler(event) {
        if (!this.imageSource) {
            return;
        }
        this.status = ScatterPlotStatus.error;
        if (event?.message) {
            this.message = event.message;
        }
        else {
            this.message = ScatterPlotChartPresentationComponent.ERROR_MESSAGE;
        }
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    handleAssetChecked(updated) {
        if (updated && this.getDataParams.chartId !== null) {
            this.selectedScatterPlotService.selectFolderable(this.getDataParams.chartId);
        }
    }
    handleAssetCopied(chartId) {
        this.selectedScatterPlotService.selectFolderable(parseInt(chartId, 10));
    }
}
ScatterPlotChartPresentationComponent.GET_STARTED_MESSAGE = 'To get started,<br>add securities or lists,<br>and add metrics to the left sidebar.';
ScatterPlotChartPresentationComponent.ERROR_MESSAGE = 'There was an error loading the chart image.';
ScatterPlotChartPresentationComponent.ɵfac = function ScatterPlotChartPresentationComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotChartPresentationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SavedScatterPlotService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.ScatterPlotAppStateManager), i0.ɵɵdirectiveInject(i4.ScatterPlotService), i0.ɵɵdirectiveInject(i5.SelectedScatterPlotService)); };
ScatterPlotChartPresentationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScatterPlotChartPresentationComponent, selectors: [["ycn-scatter-plot-chart-presentation"]], viewQuery: function ScatterPlotChartPresentationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(LegacyAssetConversionCheckerComponent, 5);
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.legacyConverter = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.presentationImage = _t.first);
    } }, standalone: false, decls: 12, vars: 8, consts: [["presentationImage", ""], [1, "chart-presentation", "user-select-none", 2, "height", "100%"], [1, "chart-item", 2, "height", "100%"], [1, "chart-wrap", 2, "height", "100%"], [1, "chart-canvas"], [3, "loaderMessage", 4, "ngIf"], ["id", "chartGetStarted", 1, "row", "row-full-height", 3, "hidden"], [1, "col-12"], [1, "get-started"], [3, "innerHTML"], [1, "chart-preview", 3, "load", "error", "hidden"], [3, "assetChecked", "assetCopied", "assetType"], [3, "loaderMessage"]], template: function ScatterPlotChartPresentationComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4);
        i0.ɵɵtemplate(4, ScatterPlotChartPresentationComponent_ycn_loading_symbol_4_Template, 1, 1, "ycn-loading-symbol", 5);
        i0.ɵɵelementStart(5, "div", 6)(6, "div", 7)(7, "div", 8);
        i0.ɵɵelement(8, "span", 9);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "img", 10, 0);
        i0.ɵɵlistener("load", function ScatterPlotChartPresentationComponent_Template_img_load_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.status = ctx.ScatterPlotStatus.ok); })("error", function ScatterPlotChartPresentationComponent_Template_img_error_9_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.errorHandler($event)); });
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(11, "ycn-legacy-asset-conversion-checker", 11);
        i0.ɵɵlistener("assetChecked", function ScatterPlotChartPresentationComponent_Template_ycn_legacy_asset_conversion_checker_assetChecked_11_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleAssetChecked($event)); })("assetCopied", function ScatterPlotChartPresentationComponent_Template_ycn_legacy_asset_conversion_checker_assetCopied_11_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleAssetCopied($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.status === "loading");
        i0.ɵɵadvance();
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(7, _c1));
        i0.ɵɵproperty("hidden", ctx.status !== ctx.ScatterPlotStatus.getStarted && ctx.status !== ctx.ScatterPlotStatus.noData && ctx.status !== ctx.ScatterPlotStatus.error);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHTML", ctx.message, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.status !== ctx.ScatterPlotStatus.ok);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("assetType", "scatter_plot");
    } }, dependencies: [i6.NgIf, i7.LegacyAssetConversionCheckerComponent, i8.LoadingSymbolComponent], encapsulation: 2 });
